import { Paper, H1, H4 } from "../../../styled";
import { Divider } from "@mui/material";

const NewPositionForm = () => {
  return (
    <div
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        margin: "30px",
      }}
    >
      <Paper>
        <div style={{ padding: "20px" }}>
          <H4> New position in group </H4>
          <Divider />
          <H4>Create an assignment for new position</H4>
        </div>
      </Paper>
    </div>
  );
};

export default NewPositionForm;
